import {Component, EventEmitter, Input, Output, TemplateRef} from '@angular/core';
import {NgxSmartModalService} from 'ngx-smart-modal';
import {AppsService} from '../../../apps.service';
import {App, AppFieldType, AppFormFieldValidation} from '../../app';

@Component({
    selector: 'rosie-app-install',
    templateUrl: './app-install.component.html',
    styleUrls: ['./app-install.component.scss'],
    standalone: false
})
export class AppInstallComponent {

  @Input() app: App;
  @Input() form: TemplateRef<any>;
  @Input() step = 1;

  @Output() install = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();
  @Output() updateAppProfile = new EventEmitter<any>();

  constructor(private apps: AppsService, private modal: NgxSmartModalService) {
  }

  get isStepped(): boolean {
    return !!this.app?.hasDiscoverableOptions;
  }

  get steps(): number {
    return this.isStepped ? 2 : 1;
  }

  get isChoiceStep(): boolean {
    return this.isStepped && this.step === 2;
  }

  get hasUnconfirmedRequiredSwitch(): boolean {
    return !!this.app?.setupData?.formFields?.some((field) => field.type === AppFieldType.Boolean
      && field.validation === AppFormFieldValidation.RequiredBoolean
      && this.app.setupData.form?.get(field.name)?.value !== true);
  }

  get formOptions(): any {
    const formOptions = this.app?.setupData?.formOptions || {};
    this.app?.setupData?.formFields?.forEach((field) => {
      const formFieldOption = formOptions[field.name] || {};
      formOptions[field.name] = {...formFieldOption, hidden: this.isFieldHidden(field.name)};
    });
    return formOptions;
  }

  private isFieldHidden(fieldName: string): boolean {
    if (this.app.isFieldActionPostInstall(fieldName)) {
      return true;
    }
    if (!this.isStepped) {
      return false;
    }
    return this.isChoiceStep
      ? !this.app.isFieldDiscoverable(fieldName)
      : this.app.isFieldDiscoverable(fieldName);
  }

  getTranslationWithAppName(translationKey: string, showPrefix = false): string {
    return this.apps.buildTranslation(translationKey, {app: this.app, showPrefix});
  }

  getAppSpecificTranslation(translationKey: string, showPrefix = false): string {
    return this.apps.buildTranslation(translationKey, {
      app: this.app,
      useAppKey: !!this.app,
      showPrefix
    });
  }

  close(): void {
    this.modal.getModal('installModal').close();
  }

}
